export default `
abrazar 
despistar 
musicalizar
acabar 
determinar 
numerar
acordar 
divulgar 
observar
actuar 
dramatizar 
olfatear
administrar 
echar 
olvidar
agarrar 
encontrar 
ostentar
allanar 
enfadar 
pensar
amasar 
enfermar 
perdonar
animar 
enfrascar 
pernoctar
aniquilar 
enfriar 
podar
anticipar 
engañar 
ponderar
aplanar 
ensuciar 
promulgar
arreglar 
equilibrar 
raptar
aterrizar 
escuchar 
reemplazar
avisar 
estirar 
reportar
bailar 
estudiar 
restar
besar 
expresar 
rotar
buscar 
hablar 
salar
calcular 
jugar 
saltar
cambiar 
justificar 
sanar
caminar 
ladrar 
secuestrar
cancelar 
lavar 
silbar
cantar 
limar 
soñar
cerrar 
llamar 
soportar
chiflar 
llevar 
sudar
conectar 
llorar 
sujetar
conjugar 
lubricar 
sumar
contactar 
luchar 
superar
contratar 
manchar 
terminar
cortar 
marchar 
testear
curar 
marchitar 
tomar
decomisar 
memorizar 
transpirar
degustar 
mirar 
trasladar
desconectar 
montar 
trotar
despegar 
multiplicar 
vomitar
aprender 
leer 
recorrer
beber 
mover 
reconocer
caer 
nacer 
rehacer
conocer 
oler 
retraer
contraer 
perder 
romper
correr 
permanecer 
saber
demoler 
prestablecer 
ser
endurecer 
prever 
suspender
enloquecer 
proveer 
ver
establecer 
querer 
volver
atender 
haber 
recoger
barrer 
imponer 
satisfacer
ceder 
lamer 
torcer
deber 
merecer 
vender
esconder 
obedecer 
vencer
favorecer 
oscurecer 
yuxtaponer
guarecer 
proponer 
yacer
abrir 
diferir 
nutrit
admitir 
discutir 
oír
adquirir 
dividir 
omitir
asistir 
escribir 
parir
batir 
exigir 
presumir
concluir 
fluir 
prohibir
conducir 
fruncir 
reir
consentir 
gemir 
resumir
construir 
huir 
salir
contribuir 
hundir 
sentir
corregir 
imprimir 
sonreír
curtir 
inscribir 
sustituir
debatir 
introducir 
transgredir
decidir 
ir 
transmitir
deducir 
latir 
unir
despedir 
lucir 
urdir
esparcir 
medir 
vestir
exprimir 
morir 
vivir
`
.trim().replace(/ /g, '').split('\n')
